<template>
  <div class="ImageParent">
    <picture>
      <source type="image/webp" :srcset="require(`@/` + data.webp_src)" />
      <img :alt="data.alt" class="Image" :src="require('@/' + data.png_src)" />
    </picture>
  </div>
</template>

<script>
export default {
  props: ['data'],
  name: 'Images',
};
</script>
<style scoped>
.ImageParent {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Image {
  max-height: 100% !important;
  max-width: 100% !important;
  height: auto !important;
}
</style>
